import { CompanyIndustryService } from '@/app/services/company-industries'
import { ErrorResponse, PaginatedQueryResponse } from '@/types/api'
import { ICompanyIndustry } from '@/types/company-industry'
import { useQuery, UseQueryOptions } from 'react-query'

export function useCompanyIndustries(
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<ICompanyIndustry>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<ICompanyIndustry>, ErrorResponse>(
    [CompanyIndustryService.GET_PATH],
    () => CompanyIndustryService.getCompanyIndustries(),
    options
  )
}
